module.exports = __webpack_public_path__ + "static/media/nextArrow.6b00b27a.svg";